import { actions } from "../../../actions/training/podcasts/podcasts";

export default function podcasts( state = {}, action ) {

    const newState = { ...state };

    switch( action.type ) {
        case actions.SET_CURRENT_PODCAST: return setCurrentPodcast( newState, action.podcast );
        case actions.SET_PODCASTS: return setPodcasts( newState, action );
        case actions.SET_PODCAST_LOCATIONS: return setPodcastLocations( newState, action.locations );
        case actions.SET_CURRENT_PODCAST_MODULES: return setCurrentPodcastModules( newState, action.modules );
        default: return state;
    }
}

function setCurrentPodcast( newState, podcast ) {
    newState.current_podcast = podcast;

    return newState;
}

function setCurrentPodcastModules( newState, modules ) {
    newState.current_podcast_modules = modules;

    return newState;
}

function setPodcasts( newState, action ) {
    newState.podcasts = action.podcasts;
    newState.pagination = action.pagination;

    return newState;
}

function setPodcastLocations( newState, locations ) {
    newState.locations = locations;

    return newState;
}


// WEBPACK FOOTER //
// src/client/reducers/training/podcasts/podcasts.js